export { default } from './InputFileReader'
